export enum ResourceEnum {
  account = "ACCOUNT",
  organization = "ORGANIZATION",
  team = "TEAM",
  project = "PROJECT",
}
